import { StyledFilterSelector } from './CategoryFilters.style';
import useMenuItems from './useMenuItems';
import {
  formatFilterMenusFiltersToStateFilters,
  formatSelectedFiltersToFilterMenus
} from './filters.formatter';
import { omit } from 'lodash';
import useSettingsService from 'components/hooks/useSettingsService';
import FilterMenusV2 from 'components/FilterMenus/FilterMenusV2';

const FilterSelector = ({
  selectedFilters,
  pmFilters,
  onCategoryFilterChange,
  filterIdx
}) => {
  const { getSettingOrDefinitionValue } = useSettingsService();

  const { customFields, isLoadingFilters } = pmFilters;
  const { customFieldsMapper, menuItemsV2 } = useMenuItems({
    customFields,
    getSettingOrDefinitionValue
  });
  const isEditMode = Object.keys(selectedFilters).length > 0;

  const isFiltersEmpty = Object.keys(selectedFilters).length === 0;

  const formattedSelectedFilters = formatSelectedFiltersToFilterMenus({
    filters: selectedFilters
  });

  const onDeleteFilter = (filterType, id) => {
    const currentSelectedFilters = formattedSelectedFilters[filterType] || [];
    const newSelectedFilters = currentSelectedFilters.filter(
      item => item.id !== id
    );
    const filtersAfterDelete = {
      ...omit(formattedSelectedFilters, filterType),
      ...(!!newSelectedFilters.length && { [filterType]: newSelectedFilters })
    };
    onCategoryFilterChange(
      formatFilterMenusFiltersToStateFilters({
        filters: filtersAfterDelete,
        customFieldsMapper
      })
    );
  };

  return (
    <StyledFilterSelector>
      <FilterMenusV2
        menuItems={menuItemsV2}
        selectedFilters={formattedSelectedFilters}
        supportAllFields
        customFieldById={true}
        setSelectedFilters={selectedFilters =>
          onCategoryFilterChange(
            formatFilterMenusFiltersToStateFilters({
              filters: selectedFilters,
              customFieldsMapper
            })
          )
        }
        onDeleteFilter={onDeleteFilter}
        buttonTitle={isEditMode ? 'Edit Rule' : 'Add Rule'}
        {...(isEditMode && { buttonIcon: 'Pencil' })}
        isLoading={isLoadingFilters}
        documentIdPrefix={filterIdx} // for anchorEl to seperate between button refs
        btnClearFiltersTitle='Clear Rule'
        onClearFilters={
          isFiltersEmpty ? null : () => onCategoryFilterChange({})
        }
      />
    </StyledFilterSelector>
  );
};

export default FilterSelector;
